var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    className: "menu-buttons__icon--x8Fb",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.343 4.929a1 1 0 11-1.416 1.414 1 1 0 011.416-1.414M4.93 19.071a.999.999 0 101.414-1.411.999.999 0 00-1.414 1.411m14.141 0a.999.999 0 10-1.41-1.414.999.999 0 001.41 1.414m0-14.142a.999.999 0 10-1.414 1.411.999.999 0 001.414-1.411M18 12A6 6 0 116 11.998 6 6 0 0118 12m-2 0c0-2.205-1.795-4-4-4-2.206 0-4 1.795-4 4 0 2.206 1.794 4 4 4 2.205 0 4-1.794 4-4m-3-8V3a1 1 0 10-2 0v1a1 1 0 102 0m0 17v-1a1 1 0 10-2 0v1a1 1 0 102 0M4 11H3a1 1 0 100 2h1a1 1 0 100-2m17 0h-1a1 1 0 100 2h1a1 1 0 100-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMode);
export default __webpack_public_path__ + "static/media/light-mode.26a715d2d89243a04c1d33299d03f994.svg";
export { ForwardRef as ReactComponent };